// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__Vpewq","toolbar":"styles_toolbar__A9FaB","gridArea":"styles_gridArea__nt1xA"};